import { flashMessage } from '/app/app/assets/js/utils/flash.js'
import { jsonRequest } from '/app/app/assets/js/utils/request.js'

export default (path, params, i18n) => ({
  originalQuantity: params.amount,

  addToCart(after) {
    this._openModal(after)
    setTimeout(this._prefillInputs, 10)
  },

  handleResponse({ type, message, data }) {
    flashMessage(message, type)

    if (data.number_of_jobs != null) this.numberOfJobs = data.number_of_jobs
    if (data.problematic_extra_ids != null)
      this.problematicOptions = data.problematic_extra_ids
    if (data.problematic_option_groups != null)
      this._highlightProblematicOptionGroups(data.problematic_option_groups)

    params.amount = this.originalQuantity
    params.description = ''
  },

  noQuantity() {
    return !/\d/.test(this.quantity)
  },

  _submit(after) {
    jsonRequest(path, 'POST', params).then((data) => {
      this.handleResponse(data)
      if (typeof after === 'function') after(data)
    })
  },

  _highlightProblematicOptionGroups(groups) {
    groups.forEach((group) => {
      const element = document.querySelector(`[data-option-group='${group}']`)
      if (element) element.classList.add('with-error')
    })
  },

  _openModal(after) {
    this.$store.modal.inline(i18n.modalTitle, '#quantity_modal_template', {
      cancel: true,
      confirm: () => {
        const amount = getInput('input')
        const description = getInput('description')

        if (!_valid(amount) || !_valid(description)) {
          _reflect(amount)
          _reflect(description)
          return false
        }

        params.amount = amount.value
        params.description = description.value
        this._submit(after)
      },
      confirmLabel: i18n.confirmLabel,
    })
  },

  _prefillInputs() {
    const amount = getInput('input')
    const description = getInput('description')

    if (amount) amount.value = params.amount || ''
    if (description) description.value = params.description || ''
  },
})

const getInput = (name) => document.getElementById(`quantity_modal_${name}`)

const _valid = (input) => !!input && String(input.value).trim() !== ''

const _reflect = (input) => {
  if (!input) return
  const error = document.getElementById(`${input.id}_error`)
  const invalid = !_valid(input)

  input.classList.toggle('with-error', invalid)
  if (error) error.hidden = !invalid
}
